<template>
    <div class="conduct">
        <section class="home-cards">
        <h4>Code Of Conduct</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/logo.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>PARENTS/ LEGAL GUARDIAN CODE OF CONDUCT AGREEMENT – 2022</h5>
                </div>
                <div class="feature-detail">
                <p> As a parent/ legal guardian of the child enrolled at Inspire Leadership School, I will abide by and follow the rules and guidelines stipulated below:</p>
                <ol>
                  <li>I will promote the emotion and physical well-being of the child and the staff at Inspire Leadership School.</li>
                  <li>I will remember that my child comes to Inspire Leadership School to be educated academically and morally.</li>
                  <li>I will uphold good parenthood through my actions, by demonstrating positive support for all children and staff at Inspire Leadership School.</li>
                  <li>I will provide support for teachers and other officials working with the children to provide a positive experience for all.</li>
                  <li>I will encourage my child to treat all children, teachers, officials and parents with respect regardless of the race, creed, colour, sex or ability.</li>
                  <li>I will treat all children, teachers, support staff and Inspire Leadership with dignity and in language, attitude, behavior, and mannerisms.</li>
                  <li>I will respect the property and the equipment used at Inspire Leadership School, both home and away.</li>
                  <li>I will not use any abusive or threatening language to any member of staff or children of Inspire Leadership School.</li>
                  <li>In a case a dispute, I will not talk to the child without the express permission of the School Administrator Senior Teacher or the parent.</li>
                  <li>I will not touch, beat or use offensive language to any child or staff of Inspire Leadership School.</li>
                </ol>
                </div>
                <div class="feature-title">
                <h5>CONDUCT SUBJECT TO DISCIPLINE</h5>
                </div>
                <div class="feature-detail">
                <p>Examples of words or actions, which will constitute a violation of the code, include, but are not limited:</p>
                <ol>
                  <li>Making physical contact with any child or staff at Inspire Leadership School.</li>
                  <li>Taunting or threating any child or staff at Inspire Leadership School.</li>
                  <li>Going into the class or office threating a child or member of staff. </li>
                  <li>Using profane and or vulgar language or mannerisms.</li>
                  <li>Defacing or damaging property belonging to the child, member of staff of Inspire Leadership School.</li>
                  <li>Being involved in any activity that would warrant the summoning of law enforcement officials.</li>
                </ol>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Conduct',
  components: { }
}
</script>

<style>
.conduct .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.conduct .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.conduct .home-cards .home-cards-main {
  padding: 1em;
  max-width: 800px;
  margin: 10px auto;
  background-color: var(--inspire-gold);
}
.conduct .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.conduct .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.conduct .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.conduct .feature p {
  color: var(--inspire-charcoal);
}
.conduct .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.conduct .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.conduct .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
